import type { ElementType } from 'react'
import { useStyletron } from 'baseui'
import { RAIL_ICON_SIZE } from '@/shared/theme/railSlot'
import {
  ModuleIcon,
  NotificationBadge,
  StatusDot,
} from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'

interface ModulePictogramProps {
  icon: ElementType<{ size?: number; title?: string; color?: string }>
  count: number
  moduleKey: string
  statusDotLabel?: string
  highlighted?: boolean
}

// An empty title drops the icon's own SVG title ("Rocket"…), which the browser would show on hover.
const ModulePictogram = ({ icon: Icon, count, moduleKey, statusDotLabel, highlighted = false }: ModulePictogramProps) => {
  const [, theme] = useStyletron()

  return (
    <ModuleIcon $highlighted={highlighted}>
      <Icon size={RAIL_ICON_SIZE} title='' color={highlighted ? theme.colors.white : undefined} />
      <NotificationBadge data-testid={`module-badge-${moduleKey}`} hidden={count === 0}>
        {count > 99 ? '99+' : count}
      </NotificationBadge>
      <StatusDot data-testid={`module-dot-${moduleKey}`} hidden={!statusDotLabel || count > 0} title={statusDotLabel} />
    </ModuleIcon>
  )
}

export default ModulePictogram
